export const formatCEP = (cep) => {
  // Remove any non-digit characters from the input string
  const digitsOnly = cep.replace(/\D/g, "");

  // Ensure we have exactly 8 digits
  const formattedCEP = digitsOnly.padEnd(8, "0");

  // Format into the CEP pattern (NNNNN-NNN)
  return `${formattedCEP.substr(0, 5)}-${formattedCEP.substr(5, 3)}`;
};

export const maskRemove = (masked) => {
  if (!masked) return masked;
  return masked.replace(/(\.|\/|-)/g, "");
};

export const onlyNumbers = (masked) => {
  if (!masked) return masked;
  return masked.replace(/\D/g, "");
};

export const maskPhone = (phone) => {
  if (!phone) return phone;
  return phone.replace(/(\d{2})(\d{2})(\d{5})(\d{4})/g, "($2) $3-$4");
};

export const isLegalPerson = (documentNumber) => {
  return documentNumber.length > 11;
};

export const documentNumberFormatter = (documentNumber) => {
  function applyNaturalPersonMask(valor) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
  }

  function applyLegalPersonMask(valor) {
    return valor.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
      "$1.$2.$3/$4-$5"
    );
  }

  if (!documentNumber) return documentNumber;

  if (documentNumber.length <= 11) {
    return applyNaturalPersonMask(documentNumber);
  }

  return applyLegalPersonMask(documentNumber);
};

export const dateFormatter = (data) => {
  if (data) {
    const date = new Date(data);
    if (date) {
      return date.toLocaleString("pt-br", {
        timeZone: "UTC",
        year: "numeric",
        month: "numeric",
        day: "numeric",
      });
    }
    return data;
  }
  return data;
};

export const isValidEmail = (email: string): boolean => {
  const isValid = String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  return !!isValid; // Convert to boolean
};

export const isValidCpf = (value) => {
  let cpf = value;
  if (Number(cpf.toString().length) !== 11) return false;
  var result = true;
  [9, 10].forEach(function (j) {
    var soma = 0,
      r;
    cpf
      .split(/(?=)/)
      .splice(0, j)
      .forEach(function (e, i) {
        soma += parseInt(e) * (j + 2 - (i + 1));
      });
    r = soma % 11;
    r = r < 2 ? 0 : 11 - r;
    if (r !== Number(cpf.substring(j, j + 1))) result = false;
  });
  return result;
};

export const isValidCnpj = (value) => {
  if (value === "") return false;
  if (value.length !== 14) return false;

  // Elimina values invalidos conhecidos
  if (
    value === "00000000000000" ||
    value === "11111111111111" ||
    value === "22222222222222" ||
    value === "33333333333333" ||
    value === "44444444444444" ||
    value === "55555555555555" ||
    value === "66666666666666" ||
    value === "77777777777777" ||
    value === "88888888888888" ||
    value === "99999999999999"
  )
    return false;

  // Valida DVs
  let tamanho = value.length - 2;
  let numeros = value.substring(0, tamanho);
  let digitos = value.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== Number(digitos.charAt(0))) {
    return false;
  }

  tamanho = tamanho + 1;
  numeros = value.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += Number(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== Number(digitos.charAt(1))) {
    return false;
  }

  return true;
};

export const formatMoney = (str) => {
  if (Number(str)) {
    return Number(str).toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });
  }

  if (str === 0) {
    return str.toLocaleString("pt-br", { style: "currency", currency: "BRL" });
  }

  return "Valor indefinido";
};

export const adressFormatter = (address) => {
  return `${address.address}, ${address.number} - ${address.neighborhood} - ${address.city} - ${address.state}, ${address.zipCode}`;
};
